import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useSearchParams } from "react-router-dom";
import { useSakusasVideoGet } from "hooks/sakusas/video/useSakusasVideoGet";
import VideoEdit from "./VideoEdit";
import VideoRead from "./VideoRead";

const VideoComponent = () => {
  const { videoId } = useParams();
  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState<string>("");
  const video = useSakusasVideoGet(videoId as string);
  useEffect(() => {
    const paramsMode = searchParams.get("mode") ?? "";
    if (paramsMode !== mode) {
      setMode(paramsMode);
    }
  }, [searchParams]);

  if (!video) {
    return null;
  }

  return (
    <>
      {mode !== "edit" && <VideoRead video={video} />}
      {mode === "edit" && <VideoEdit video={video} />}
    </>
  );
};

export default VideoComponent;
